<template>
  <v-row class="mx-auto">
    <v-col cols="12">
      <base-material-card color="primary" icon="mdi-barcode-scan" inline class="px-5 py-4">
        <template v-slot:after-heading>
          <div class="display-2-custom font-weight-light title-page-bp">
            {{ title }}
          </div>
        </template>

        <v-row class="mx-auto">
          <v-col cols="12">
            <validation-provider v-slot="{ errors }" rules="required">
              <v-text-field
                id="titulo-calculo-bp"
                v-model="campos.titulo"
                class="my-0"
                label="Título"
                outlined
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
        </v-row>

        <v-row class="mt-n3 mx-auto" align="center">
          <v-col cols="4" class="pt-0">
            <v-menu
              v-model="menuDataBase"
              :close-on-content-click="false"
              :nudge-right="100"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <validation-provider v-slot="{ errors }" rules="required|min:7">
                  <v-text-field
                    id="date-picker-database-calculo-bp"
                    v-model="campos.monthDataBaseFormatted"
                    v-mask="'##/####'"
                    :error-messages="errors"
                    type="tel"
                    label="Data Aplicação COGE"
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    @blur="campos.monthDataBase = parseMonth(campos.monthDataBaseFormatted)"
                  />
                </validation-provider>
              </template>
              <v-date-picker
                v-model="campos.monthDataBase"
                type="month"
                :landscape="false"
                locale="pt-br"
                @input="
                  menuDataBase = false;
                  campos.monthDataBaseFormatted = formatMonth(campos.monthDataBase);
                "
              />
            </v-menu>
          </v-col>

          <v-col cols="4" class="pt-0">
            <v-menu
              v-model="menuDataCompra"
              :close-on-content-click="false"
              :nudge-right="100"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <validation-provider v-slot="{ errors }" rules="required">
                  <v-text-field
                    id="date-picker-data-inicial-calculo-bp"
                    v-model="campos.dataCompraFormatted"
                    v-mask="'##/##/####'"
                    :error-messages="errors"
                    type="tel"
                    label="Data Compra Inicial"
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    @blur="campos.dataCompra = parseDate(campos.dataCompraFormatted)"
                  />
                </validation-provider>
              </template>
              <v-date-picker
                v-model="campos.dataCompra"
                locale="pt-br"
                @input="
                  menuDataCompra = false;
                  campos.dataCompraFormatted = formatDate(campos.dataCompra);
                "
              />
            </v-menu>
          </v-col>

          <v-col cols="4" class="pt-0">
            <v-menu
              v-model="menuDataCompraAte"
              :close-on-content-click="false"
              :nudge-right="100"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <validation-provider v-slot="{ errors }" rules="required">
                  <v-text-field
                    id="date-picker-data-final-calculo-bp"
                    v-model="campos.dataCompraFormattedAte"
                    v-mask="'##/##/####'"
                    :error-messages="errors"
                    type="tel"
                    label="Data Compra Final"
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    @blur="campos.dataCompraAte = parseDate(campos.dataCompraFormattedAte)"
                  />
                </validation-provider>
              </template>
              <v-date-picker
                v-model="campos.dataCompraAte"
                locale="pt-br"
                @input="
                  menuDataCompraAte = false;
                  campos.dataCompraFormattedAte = formatDate(campos.dataCompraAte);
                "
              />
            </v-menu>
          </v-col>
        </v-row>

        <v-row class="mx-auto">
          <v-col cols="12">
            <v-textarea
              id="CFOPs"
              v-model="campos.cfops"
              class="mt-4 pt-0"
              label="CFOPs"
              placeholder="Insira os CFOPs que devem participar do, um por linha. Ex.:

    1551
    2406"
              rows="5"
              no-resize
              clearable
              clear-icon="mdi-close-circle"
            />
          </v-col>
        </v-row>

        <v-row class="mx-auto">
          <v-col cols="6">
            <v-text-field v-model="campos.valorOdc" label="Valor de ODC (R$)" outlined type="number" min="0" step="0.01" />
          </v-col>
          <v-col cols="6">
            <v-checkbox v-model="campos.atualizarCogeIcmsNr" class="my-0" label="Atualizar por COGE apenas parcela de ICMS_NR?" />
          </v-col>
        </v-row>
      </base-material-card>
    </v-col>
  </v-row>
</template>

<script>
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';

  export default {
    mixins: [dateFormatterMixins],

    props: {
      title: {
        type: String,
        required: true
      },
      items: {
        type: Object,
        default: () => {}
      }
    },

    data() {
      return {
        menuDataCompra: false,
        menuDataCompraAte: false,
        menuDataBase: false,
        campos: {
          titulo: '',
          dataCompra: '',
          dataCompraAte: '',
          monthDataBase: '',
          dataCompraFormatted: '',
          dataCompraFormattedAte: '',
          monthDataBaseFormatted: '',
          cfops: '',
          valorOdc: 0,
          atualizarCogeIcmsNr: false
        }
      };
    },

    mounted() {
      if (this.$route.params.id) {
        this.fillFields();
      }
    },

    methods: {
      fillFields() {
        let bancoPrecosCalculos = this.items;

        this.campos = {
          titulo: bancoPrecosCalculos.titulo,
          dataCompraFormatted: bancoPrecosCalculos.data_inicial ? this.formatDate(bancoPrecosCalculos.data_inicial) : '',
          dataCompra: bancoPrecosCalculos.data_inicial ? this.formatDateToPicker(bancoPrecosCalculos.data_inicial) : '',
          dataCompraFormattedAte: bancoPrecosCalculos.data_final ? this.formatDate(bancoPrecosCalculos.data_final) : '',
          dataCompraAte: bancoPrecosCalculos.data_final ? this.formatDateToPicker(bancoPrecosCalculos.data_final) : '',
          monthDataBaseFormatted: bancoPrecosCalculos.data_base ? this.formatMonth(bancoPrecosCalculos.data_base) : '',
          monthDataBase: bancoPrecosCalculos.data_base ? this.formatMonthToPicker(bancoPrecosCalculos.data_base) : '',
          cfops: bancoPrecosCalculos.cfops ? bancoPrecosCalculos.cfops : '',
          valorOdc: bancoPrecosCalculos.valor_odc ? bancoPrecosCalculos.valor_odc : 0,
          atualizarCogeIcmsNr: bancoPrecosCalculos.atualizar_coge_icms_nr ? bancoPrecosCalculos.atualizar_coge_icms_nr : false
        };
      },

      exportData() {
        return {
          titulo: this.campos.titulo,
          data_inicial: this.campos.dataCompra,
          data_final: this.campos.dataCompraAte,
          data_base: this.campos.monthDataBase + '-01',
          cfops: this.campos.cfops,
          valor_odc: this.campos.valorOdc,
          atualizar_coge_icms_nr: this.campos.atualizarCogeIcmsNr
        };
      }
    },

    watch: {
      items() {
        this.fillFields();
      }
    }
  };
</script>

<style>
  .col-date-bp {
    min-width: 160px !important;
  }
  .col-divisor-date-bp {
    padding-top: 36px;
  }

  .display-2-custom {
    font-size: 1.5625rem;
    font-weight: 400;
    line-height: 1.4em;
    letter-spacing: normal !important;
    font-family: 'Gotham Rounded' !important;
  }

  @media screen and (max-width: 492px) {
    .col-date-bp {
      -ms-flex: 0 0 100%;
      flex: 0 0 100%;
      max-width: 100%;
      min-width: 100%;
      padding-bottom: 0px;
      padding-top: 0px;
    }
    .col-divisor-date-bp {
      padding: 0 12px 0 12px !important;
      margin-top: -10px;
      margin-bottom: -10px;
      margin-left: auto;
      margin-right: auto;
      width: 6em;
    }

    .title-bp {
      margin-bottom: 0px;
      padding-bottom: 0px;
    }

    .last-date-page-bp {
      margin-top: 8px;
    }

    .display-2-custom {
      font-size: 1.5625rem;
      font-weight: 400;
      line-height: 1.4em;
      letter-spacing: normal !important;
      font-family: 'Gotham Rounded' !important;
    }

    .title-page-bp {
      font-size: 3.6vw !important;
    }
  }
</style>
